import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToolsService } from '../../core/services/tools.service';
import { AuthService } from '../../core/services/auth.service';
import { AnalyticsService } from '../../core/services/analytics.service';
import { TranslateService } from '@ngx-translate/core';
declare var google: any;

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit {

  public form: UntypedFormGroup;

  public submitAttempted = false;
  public submitSocialAttempted = false;
  public loading = false;
  public errorMsg: string;

  constructor(@Inject(PLATFORM_ID) protected platformId, private activatedRoute: ActivatedRoute, private toolsService: ToolsService, private fb: UntypedFormBuilder, private authService: AuthService, private analytics: AnalyticsService, private router: Router, private translateService: TranslateService ) { };

  ngOnInit(): void {

    this.generateForm(this.activatedRoute.snapshot.queryParams.email);

    if (isPlatformBrowser(this.platformId)) {
      const signupStepBeforeSignupUrl = this.toolsService.getPreviousUrl();
      try {
        sessionStorage.setItem('signup:step:before:signup:url', signupStepBeforeSignupUrl);
      } catch (error) {
      }
    }

  }

  generateForm(email = '') {
    this.form = this.fb.group({
      // user
      firstName: ['', [Validators.required]],
      email: [email, [Validators.required, Validators.email]],
      password: ['', [Validators.required]],
    });
  }


  submit() {
    this.submitAttempted = true;
    this.errorMsg = null;

    if (!this.form.valid) {
      this.errorMsg = ' ';
      return false;
    }

    this.loading = true;

    this.createUser();

  }

  createUser() {
    const signupPayload = {
      email: this.form.get('email').value,
      password: this.form.get('password').value,
      firstName: this.form.get('firstName').value,
    };
    this.authService.signup(signupPayload).subscribe(
      (res) => {
        this.analytics.trackEvent('sign_up', 'engagement', 'email');
        this.analytics.trackProductAnalyticsEvent('sign_up', {
          medium: 'email',
        });
        this.analytics.trackTikTokPixel('CompleteRegistration', 'email');

        this.router.navigate(['/signup/merchant']);
      },
      (err) => {
        this.errorMsg = err.errMsg;
        this.loading = false;
      }
    );
  }

  socialError() {
    this.errorMsg = this.translateService.instant('GENERAL.error');
  }

}
